import { useTranslation } from "react-i18next";
import { Field, FieldGroup, FieldLabel } from "@/components/ui/field";
import { Skeleton } from "@/components/ui/skeleton";

// Usual number of answers on a dilemma — only used to size the skeleton
// while the generation is running.
const ANSWER_SKELETON_COUNT = 4;

const AiWritingAssistantReviewSkeleton = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <Field>
        <FieldLabel required>{t("modules.dilemmas.form.topic")}</FieldLabel>
        <Skeleton className="h-10 w-full" />
      </Field>

      <FieldGroup className="gap-4">
        <Field>
          <FieldLabel required>{t("modules.dilemmas.form.title")}</FieldLabel>
          <Skeleton className="h-9 w-full" />
        </Field>

        <Field>
          <FieldLabel required>
            {t("modules.dilemmas.form.description")}
          </FieldLabel>
          <Skeleton className="h-20 w-full" />
        </Field>

        <Field>
          <FieldLabel required>
            {t("modules.dilemmas.form.the_question")}
          </FieldLabel>
          <Skeleton className="h-9 w-full" />
        </Field>

        <div className="flex flex-col gap-4">
          {Array.from({ length: ANSWER_SKELETON_COUNT }).map((_, index) => (
            <div key={index} className="flex gap-2 lg:gap-4">
              <Skeleton className="size-6 translate-y-16 rounded-sm" />
              <div className="flex-1 flex flex-col gap-1">
                <div className="px-3 pb-3 flex flex-col gap-2">
                  <Skeleton className="mt-3 h-7 w-24" />
                  <Skeleton className="min-h-20 w-full" />
                </div>
                <hr />
                <div className="p-3 flex flex-col gap-2">
                  <Skeleton className="h-5 w-40" />
                  <Skeleton className="min-h-20 w-full" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </FieldGroup>
    </div>
  );
};

export default AiWritingAssistantReviewSkeleton;
